<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="370">
            <v-card>
                <div class="modal-close-btn">
                    <div class="cross-style" @click="closeModal()">
                        x
                    </div>
                </div>
                <div class="modal-content">
                    <v-card-title class="center pt-0">
                        {{ $vuetify.lang.t('$vuetify.resetPinForm.resetPin') }}
                    </v-card-title>
                    <v-form
                        lazy-validation
                        ref="form"
                        v-model="valid">
                        <v-text-field
                            :label="$vuetify.lang.t('$vuetify.resetPinForm.pin')"
                            v-model="form.pin"
                            v-mask="'####'"
                            placeholder=" "
                            type="password"
                            :rules="pinRules"
                            :error-messages="errors.pin"
                            @keyup="countPin(form.pin, 'pin')"
                            autocomplete="off">
                        </v-text-field>
                        <v-text-field
                            ref="confirm_pin"
                            :label="$vuetify.lang.t('$vuetify.resetPinForm.confirmPin')"
                            v-model="form.confirm_pin"
                            placeholder=" "
                            v-mask="'####'"
                            type="password"
                            :rules="pinRules"
                            :error-messages="errors.confirm_pin"
                            @keyup="countPin(form.confirm_pin, 'confirm_pin')"
                            autocomplete="off">
                        </v-text-field>
                    </v-form>
                </div>
                <div class="modal-save-btn">
                    <v-btn
                        width="200"
                        color="primary"
                        @click="submitResetPassword()">
                        {{ $vuetify.lang.t('$vuetify.resetPinForm.save') }}
                    </v-btn>
                </div>
                <v-card-actions>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
    name: 'ResetPinForm',

    directives: {
        mask
    },

    props: {
        updateEmployeeId: {
            type: Number,
            default: null
        }
    },
    computed: {
        pinRules () {
            return [
                v => this.$validator.hasValue(v, this.trans.resetPinForm.incorrectPin),
                v => this.$validator.lengthExactly(v, 4, this.trans.resetPinForm.incorrectPin)
            ]
        },
        pinError () {
            return this.trans.resetPinForm.msgPinDontmatch
        },
        msgSaveSuccess () {
            return {
                title: this.trans.resetPinForm.congratulation,
                text: this.trans.resetPinForm.msgSaveSuccess,
                type: 'success'
            }
        }
    },
    data () {
        return {
            dialog: false,
            valid: true,
            form: {
                pin: '',
                confirm_pin: ''
            },
            errors: {},
            employeeId: ''
        }
    },
    methods: {
        openModal () {
            this.dialog = true
        },

        closeModal () {
            this.$refs.form.resetValidation()
            this.dialog = false
            this.errors = {}
            this.form = {
                pin: '',
                confirm_pin: ''
            }
        },

        countPin (code, type) {
            if (type === 'pin' && code.length === 4) {
                this.$refs.confirm_pin.focus()
            } else if (type === 'confirm_pin' && code.length === 4) {
                if (this.form.pin !== this.form.confirm_pin) {
                    this.errors = {
                        pin: this.pinError,
                        confirm_pin: this.pinError
                    }
                } else {
                    this.errors = {}
                }
            }
        },

        async submitResetPassword () {
            if (!this.$refs.form.validate() || Object.keys(this.errors).length > 0) {
                return
            }
            this.resetPassword()
        },

        async resetPassword () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.put(`employee/pin/${this.updateEmployeeId}/reset`, this.form)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-updated')
                this.closeModal()
                this.$store.dispatch('setLoading', false)
                this.$notify(this.msgSaveSuccess)
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
            }
        }
    },

    mounted () {
        this.registerLang({
            resetPinForm: [
                'incorrectPin',
                'msgPinDontmatch',
                'congratulation',
                'msgSaveSuccess'
            ]
        })
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                if (this.dialog) {
                    this.$refs.form.resetValidation()
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
